import React from 'react';
import GroupedChecksCardContent from './GroupedChecksCardContent/index';
const TileWithGroup = props => {
  const {
    check,
    rowIndex,
    selectedCheck,
    setSelectedCheck,
    currentMode,
  } = props;
  return (
    <div>
      <GroupedChecksCardContent
        check={check}
        rowIndex={rowIndex}
        key={`tile-${check.id}`}
        isSelected={check?.id === selectedCheck}
        setSelectedCheck={setSelectedCheck}
        currentMode={currentMode}
      />
    </div>
  );
};

export default TileWithGroup;
